import styled from 'styled-components';
import { color, typography } from 'styles/settings';
import { withModifiers } from 'utils/styles';

import InputComponent from 'components/text-input';

export const SearchableContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SortableContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`;

export const Input = styled(InputComponent)`
  background-color: white;
  margin-bottom: 0;
`;

export const StyledLabel = styled.span`
  color: ${color.neutral.black};
  font-size: ${({ fontSize }) => fontSize && typography.size.rg};
  margin-bottom: 4px;
  /* stylelint-disable-line */
  ${withModifiers('invalid')`
    border-color: ${color.ui.danger};
    color: ${color.ui.danger};
  `};
  /* stylelint-enable-line */
`;
